import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {I18nService} from '../gui/i18n.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ApiEndpoints} from '../../_constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  private http = inject(HttpClient);
  private i18nService = inject(I18nService);
  private apiEndpoints = inject(ApiEndpoints);


  getAacDescriptions(productCode: string): Observable<{[code: string]: string}> {
    return this.http.get<any[]>(`${this.apiEndpoints.utilitiesProductDescriptions}?products=${productCode}&lang=${this.i18nService.currentLangShortCode}`).pipe(
      map((v: any[]) => Object.fromEntries(
        v.find(e => e.product === productCode).aacCodes.map(e => ([e.code, e.codeDescription]) as [string, string])
      ))
    );
  }

}
